import React from "react";
import { MDBAnimation } from "mdbreact";

export default function Work() {
  return (
    <MDBAnimation reveal type="fadeIn" duration="500ms">
      <main className="page-content">
        <div className="card_1">
          <div className="content">
            <h2 className="title">UI/UX Web Designs</h2>
            <p className="copy">
              We create web designs in ways that no one else does. Our
              Animations and Layouts are will blow your mind.
            </p>
            <button className="btn">Order</button>
          </div>
        </div>
        <div className="card_1">
          <div className="content">
            <h2 className="title">Back-End Development</h2>
            <p className="copy">
              Building and Integrating APIs is one of our greatest speciality.
              We will provide you with well-organized Back-end system to work
              on.
            </p>
            <button className="btn">Order</button>
          </div>
        </div>{" "}
        <div className="card_1">
          <div className="content">
            <h2 className="title">Full-Stack Web Development</h2>
            <p className="copy">
              Business Websites are our speciality. We create one of the most
              powerful presenting professional websites to the world. If you
              don't believe it then try us.
            </p>
            <button className="btn">Book Now</button>
          </div>
        </div>
        <div className="card_1">
          <div className="content">
            <h2 className="title">Back-End Anroid Development</h2>
            <p className="copy">
              Building and Integrating APIs is one of our greatest speciality.
              We will provide you with well-organized Back-end system to work
              on.
            </p>
            <button className="btn">Order</button>
          </div>
        </div>
        <div className="card_1">
          <div className="content">
            <h2 className="title">Full-Stack Mobile Development</h2>
            <p className="copy">
              We are developing Android and iOS Application with Java,
              Kotlin,Swift, React Native, and Flutter with beautiful layouts.
            </p>
            <button className="btn">Order Now</button>
          </div>
        </div>
        <div className="card_1">
          <div className="content">
            <h2 className="title">UI/UX Mobile Designs</h2>
            <p className="copy">
              Mobile Interface designed by us is very user friendly and have
              beautiful responsive and dynamic layout.
            </p>
            <button className="btn">Order Now</button>
          </div>
        </div>
      </main>
    </MDBAnimation>
  );
}
